// extracted by mini-css-extract-plugin
export default {"container":"layout_container__oWUqW","outletWithMenu":"layout_outletWithMenu__Cqcq1","outletWithoutMenu":"layout_outletWithoutMenu__Hy5aM"};